//menu js start
$(document).ready(function () {
  window._klOnsite = window._klOnsite || [];
 // $('.face-product .form-input-custm input:first').trigger('click');
// $(document).on('click','.banner__buttons a[href="#signup-popup"]', function(e){
//     e.preventDefault();
//     $('#signup-button-popup').click();
// });
  
// $('body').on('click','legend.form__label.custom_shade_finder',function () {
// $('.custom_shade_finer_popup_outer').css('display', 'flex');
//   $('body').addClass('is-body-active');

// });
// $('body').on('click','.custom_shade_finer_popup svg',function () {
// $('.custom_shade_finer_popup_outer').css('display', 'none');
//  $('body').removeClass('is-body-active');
// });
  

  
// $(document).mouseup(function(e) {
//   var container = $(".custom_shade_finer_popup_outer");
//   // if the target of the click isn't the container nor a descendant of the container
//   if (!container.is(e.target) && container.has(e.target).length === 0) 
//   {
//       container.hide();
//       $('body').removeClass('is-body-active');
//   }
// });
     
    var lockSmithLen = $('body').find('#locksmith-content').length;
    if(lockSmithLen > 0){
       $('body').addClass('lockSmithExists'); 
    } else {
       $('body').removeClass('lockSmithExists');  
    }
  
  //toggle the component with class accordion_body
  $(".accordion_head").click(function () {
    if ($(".accordion_body").is(":visible")) {
      $(".accordion_body").slideUp(300);
      $(".arrow_icon").removeClass("clicked-in");
      $(".plusminus").text("+");
    }
    if ($(this).next(".accordion_body").is(":visible")) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text("+");
      $(this).find(".arrow_icon").removeClass("clicked-in");
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).find(".arrow_icon").addClass("clicked-in");
      $(this).children(".plusminus").text("-");
    }
  });

  if ($(".video-with-product .image-cover")) {
    $(".video-with-product .image-cover").on("click", function() {
      $(this).hide();
      var videoSection = $(this).next("video");
      if (videoSection) {
        videoSection.removeClass("pause-video");
        videoSection.get(0).play();
      }
    })
  }
  
});
// add body class scrolled-none
$(function () {
  $(".menu-trigger .open-menu").click(function () {
    $("body").css("overflow", "hidden");
  });
  $(".menu-trigger .close-menu").click(function () {
    $("body").css("overflow", "unset");
  });
});
// add class scrolled
$(function () {
  var header = $(".section-header .header2, .header-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      header.addClass("scrolled");
    } else {
      header.removeClass("scrolled");
    }
  });
});
$(document).on("scroll load resize", function () {
  var annHeight = $(".announcement-bar").height();
  var ttl = annHeight + 10;
  $(".header-mobile").css("top", ttl);
});
// menu js end

$(document).ready(function () {
  var annHeight = $(".announcement-bar").height();
  var ttl = annHeight + 10;
  $(".header-mobile").css("top", ttl);
});

$(document).on("change", "fieldset.js.product-form__input input", function (e) {
  var get_sel_id = $(this).attr("data-id");
  $.ajax({
    url: window.location.href,
    type: "GET",
    dataType: "html",
    success: function (data) {
      //console.log(data);
      $(".popup_inner_wrappper").html("");
      $(data)
        .find(".popup_inner_wrappper .product-popup-modal__opener")
        .each(function () {
          var get_index = $(this).parent().attr("data-index");
          var get_html = $(this).parent().html();
          $(".popup_inner_wrappper[data-index=" + get_index + "]").html(
            get_html
          );
        });

      // var get_index = $(data).find('.popup_inner_wrappper[data-var='+get_sel_id+'] .product-popup-modal__opener').parent().index();
      // alert(get_index);
      // var get_content = $(data).find('.popup_inner_wrappper[data-var='+get_sel_id+'] .product-popup-modal__opener').parent().html();
      //            $(".popup_inner_wrappper[data-var="+get_sel_id+"]").html(get_content);
      $(".popup_content_wrapper").html(
        $(data).find(".popup_content_wrapper").html()
      );
      $(data)
        .find(".modal_inner_wrappper .product-popup-modal__content")
        .each(function () {
          var get_index = $(this).parent().attr("data-index");
          var get_html = $(this).parent().parent().html();
          $(".modal_inner_wrappper[data-index=" + get_index + "]")
            .parent()
            .html(get_html);
        });
    },
  });

  var get_id = $(this).attr("data-price");

  $(".price_wrapper").html(get_id);
  $("fieldset.js.product-form__input label").removeClass("active");
  var get_title = $(this).next().data("name");
  $(this).next().addClass("active");
  $(".tool_tip_wrappper").removeClass("active");
  $(".tool_tip_wrappper").addClass("hidden");
  $(this).next().find(".tool_tip_wrappper").removeClass("hidden");
  $(this).next().find(".tool_tip_wrappper").addClass("active");
  var get_desc = $(this).next().data("desc");
  //     if(typeof get_desc != 'undefined'){
  //     $(".custom_variant_description").html(get_desc);
  //     }
  // $("p.custom_variant_title").html(get_title);
});
$(document).on("click", "button.product-popup-modal__toggle", function () {
  $("modal-dialog.product-popup-modal").removeAttr("open");
  $("body").removeClass("overflow-hidden");
});
$(".header__icon--search").click(function () {
  $("sticky-header").addClass("custom_scr");
});

$(".search-modal").click(function () {
  $("sticky-header").removeClass("custom_scr");
});

// megamenu slider js start
$(document).ready(function () {
  //           setTimeout(function() {
  // $("body").removeClass('animation_class');
  //  }, 2500);
  setTimeout(function () {
    $("body").addClass("animation_class_move");
  }, 100);
  $(".megamenu_inner_products.multiple-items_slick_slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      '<div class="slick-prev main_custom_slide"><img src="https://cdn.shopify.com/s/files/1/0627/7768/8232/files/next_image.png?v=1676443790"></div>',
    nextArrow:
      '<div class="slick-next main_custom_slide"><img src="https://cdn.shopify.com/s/files/1/0627/7768/8232/files/next_image.png?v=1676443790"></div>',
  });
  $(".mega-menu__list li").hover(function () {
    $(".megamenu_inner_products.multiple-items_slick_slider").css(
      "opacity",
      "0"
    );

    $(".megamenu_inner_products").addClass("hidden");
    $this = $(this);
    var get_curr_handle = $this.attr("data-menu");

    $(
      ".megamenu_inner_products[data-menu=" + get_curr_handle + "]"
    ).removeClass("hidden");

    setTimeout(function () {
      $(
        ".megamenu_inner_products.multiple-items_slick_slider[data-menu=" +
          get_curr_handle +
          "]"
      ).slick("setPosition");
      $(
        ".megamenu_inner_products.multiple-items_slick_slider[data-menu=" +
          get_curr_handle +
          "]"
      ).css("opacity", "1");
      var main_height =
        $(
          ".megamenu_inner_products:visible .products_details_wrappper .image_products"
        ).height() / 2;
      $(".megamenu_inner_products:visible .main_custom_slide").css(
        "top",
        main_height
      );
    }, 50);
    //$('.megamenu_inner_products.multiple-items_slick_slider').slick('setPosition');
  });
  $("nav.header__inline-menu .list-menu--inline li summary").hover(function () {
    $(".megamenu_inner_products.multiple-items_slick_slider").css(
      "opacity",
      "0"
    );

    $(".megamenu_inner_products").addClass("hidden");
  });

  $(".product__accordion.accordion details summary").click(function (e) {
    e.preventDefault();
    $(this)
      .parents(".product__accordion.accordion")
      .find(".accordion__content")
      .slideToggle("active-accordian");
    $(".accordion__content")
      .not(
        $(this)
          .parents(".product__accordion.accordion")
          .find(".accordion__content")
      )
      .slideUp("active-accordian");
  });
});

//  Media Alt PDP Click
// $(".media_alt_click.product__info-container label").on("click", function () {
//   var get_width = $(window).width();
//
//   if (get_width < 769) {
//     var get_var_id = $(this).attr("data-var");
//     var get_curr = $(".product_url_media_alt").val();
//
//     var set_url = get_curr + "?variant=" + get_var_id;
//     $(".variant_image_individual_wrapp").hide();
//     $(".variant_image_individual_wrapp .product-slider").removeClass(
//       "slider_active_custom"
//     );
//
//     $(".variant_image_individual_wrapp[data-id=" + get_var_id + "]").show();
//     $(
//       ".variant_image_individual_wrapp[data-id=" +
//         get_var_id +
//         "] .product-slider"
//     ).addClass("slider_active_custom");
//
//     var mySwiper = document.querySelector(".slider_active_custom").swiper;
//     mySwiper.destroy();
//     const productSlider = new Swiper(".slider_active_custom", {
//       direction: "horizontal",
//       loop: true,
//       speed: 1000,
//       effect: "fade",
//       autoHeight: true,
//       allowTouchMove: true,
//       fadeEffect: {
//         crossFade: true,
//       },
//
//       navigation: {
//         nextEl: ".slider_active_custom",
//       },
//
//       pagination: {
//         el: ".swiper-pagination",
//         type: "fraction",
//       },
//     });
//     $("html, body").animate({ scrollTop: 0 }, "slow");
//   }
//   if (get_width < 769) {
//     // $(".loader_pdp_wrappper").addClass('active');
//   }
//   $.ajax({
//     url: set_url,
//     type: "GET",
//     dataType: "html",
//     success: function (data) {
//       // $(".variant_specific_wrappper").html($(data).find('.variant_specific_wrappper').html());
//       $(".custom_product_recommendations_wrappper").html(
//         $(data).find(".custom_product_recommendations_wrappper").html()
//       );
//       //           reloadScripts();
//       // $(".loader_pdp_wrappper").removeClass('active');
//
//       //   var get_width = $(window).width();
//     },
//   });
// });

$(".slider-button").click(function () {
  setTimeout(function () {
    $(".slider-counter--total").text(varCount);
  }, 100);
});
$(document).on("click", "div#insta-feed h2", function () {
  window.open("https://www.instagram.com/farahomidibeauty/", "_blank");
});
// $("a#read_reviews").click(function(e) {
//     e.preventDefault();
//     $('html, body').animate({
//         scrollTop: $(".js-oke-widgetSize.oke-is-large").offset().top
//     }, 1000);
// });

// $("#signup-button-popup").click(function (e) {
//   e.preventDefault();
//   $(".modal_newsllter2").css("display", "flex");
//   $("body").addClass("overflow");
//   // const isMobile = window.innerWidth <= 768;
    
//   // if (isMobile) {
//   //   window._klOnsite.push(['openForm', 'RxKZaT']); // Mobile Tap-to-Text
//   // } else {
//   //   window._klOnsite.push(['openForm', 'TT4aZv']); // Desktop Form
//   // }
  
// });
$(".close_popp2").click(function () {
  $("body").removeClass("overflow");
});
$("fieldset.js.product-form__input label").on("click", function () {
   
  var get_width = $(window).width();

  var get_var_id = $(this).attr("data-id");
  var get_curr = $(".product_url_media_alt").val();
 
  var set_url = get_curr + "?variant=" + get_var_id;

  if (get_width < 769) {
    // $(".loader_pdp_wrappper").addClass('active');
  }

   
  $.ajax({
    url: set_url,
    type: "GET",
    dataType: "html",
    success: function (data) {
     setTimeout(function(){
      // $(".variant_specific_wrappper").html($(data).find('.variant_specific_wrappper').html());
      $(".custom_product_recommendations_wrappper").html(
        $(data).find(".custom_product_recommendations_wrappper").html()
      );
       }, 1200);
      //           reloadScripts();
      // $(".loader_pdp_wrappper").removeClass('active');

      //   var get_width = $(window).width();
    
    },
  });
});
 
$(document).ready(function () {
  $(".variant_image_individual_wrapp").each(function () {
    $(this).find("video").trigger("play");
  });
});
